angular.module('bmsApp.marketing').controller('CustomerGroupIndexCtrl', function ($scope,
																				  $rootScope,
																				  $log,
																				  CustomerGroupSvc,
																				  AppSettingsSvc,
																				  ngTableParams,
																				  $state,
																				  $window,
																				  $cookies,
																				  $localStorage,
																				  $ngBootbox) {

	$scope.groups = {};
	$scope.loading = true;
	$scope.updating = false;
	$scope.customerGroupCount = 0;
	$scope.mailchimp = {
		loaded: false,
		apiKeyValid: false
	};

	AppSettingsSvc
		.index()
		.then(function (response) {
			var mailchimpData = response.data;
			if (mailchimpData.settings.mailchimp_apikey_verified == 1) {
				$scope.mailchimp.apiKeyValid = true;
			}
			$scope.mailchimp.loaded = true;
		}, function (error) {
			$scope.errors = error;
		})
	;

	var defaultCustomerGroupParams = function () {
		return {
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {
				customer_group: 'asc' // initial sorting
			},
			filter: {}
		};
	};

	var initialCustomerGroupParams = function () {
		if (angular.isDefined($localStorage.customerGroupIndexParams)) {
			return angular.extend({}, defaultCustomerGroupParams(), $localStorage.customerGroupIndexParams);
		}
		else {
			return angular.extend({}, defaultCustomerGroupParams());
		}
	};

	var params = initialCustomerGroupParams();

	// copy the filters to a workable state
	$scope.customerGroupFilters = angular.copy(params.filter);

	$scope.tableParams = new ngTableParams(params, {
		total: 0, // length of data
		counts: $scope.config.table.settings.counts, // available page counts
		getData: function ($defer, params) {
			$localStorage.customerGroupIndexParams = params.$params;
			$scope.updating = true;
			CustomerGroupSvc.index(params.$params)
				.then(function (response) {
					params.total(response.data.customer_group_filtered_count);
					$scope.customerGroupCount = response.data.customer_group_filtered_count;
					$scope.groups = response.data.customer_group_collection;
					$scope.loading = $scope.updating = false;

					var tableCount = {
						total: $scope.customerGroupCount,
						page: response.data.customer_group_collection.length
					};

					$scope.$emit('customerGroupIndexUpdated', tableCount);
					$defer.resolve(response.data.customer_group_collection);

					// Check if we've exceeded our page size, if we have, go back
					if (response.data.customer_group_filtered_count > 0 && !response.data.customer_group_collection.length) {
						let newParams = angular.copy($scope.tableParams.$params);
						newParams.page--;
						angular.extend($scope.tableParams.$params, newParams);
					}
				});
		}
	});

	// Store the table params whenever anything changes
	$scope.$watch('tableParams.$params', function (value) {
		if (angular.isObject(value)) {
			$cookies.customerGroupIndexParams = JSON.stringify(value);
		}
	}, true);

	// update text search without having to click apply
	$scope.filterChanged = function () {
		$scope.tableParams.$params.filter.search = $scope.customerGroupFilters.search;
	};

	$scope.rowClicked = function (group) {
		//if (group.customer_group !== 'Opted In' && group.customer_group !== 'Opted Out') {
			$state.go("main.marketing.customerGroupIndex.customerGroupEdit", {id: group.id});
		//}
	};

	$scope.export = function ($event, group) {
		$window.location.href = '/api/marketing/customerGroup/export/' + group.id;
		$event.stopPropagation();
	};

	$scope.confirmDelete = function ($event, group) {
		$event.stopPropagation();
		$ngBootbox.confirm('Are you sure you want to do this?')
			.then(function () {
				$scope.updating = true;
				CustomerGroupSvc.remove(group.id)
					.then(function (response) {
						$scope.tableParams.reload();
						$scope.updating = false;
					});
			});

	};


});
